<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <!-- <el-form-item label="次卡种类">
                  <el-input  v-model="queryForm.cardId"></el-input>
              </el-form-item> -->
              <el-form-item label="购买">
                  <el-input style='width: 186px' v-model="queryForm.buyId"></el-input>
              </el-form-item>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelect
                    title='选择用户'
                    labelName='userName'
                    labelValue='id'
                    :value='queryForm.userId'
                    :limit='1'
                    style='width: 186px'
                    size='small'
                    placeholder='请选择用户'
                    @getValue='getValue1'
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    queryEntityUrl='/mpp/user/get'
                >
                </GridSelect>
              </el-form-item>
              <el-form-item label="使用次数">
                  <el-input style='width: 186px' v-model="queryForm.useTimes"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopTimescardUseList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopTimescardUse"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopTimescardUse(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopTimescardUse(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopTimescardUseList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopTimescardUseList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopTimescardUseList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardId"
        label="次卡种类"
        min-width="180"
      >
        <template slot-scope='scope'>
          <div v-if="scope.row.card">
            <div style='text-align: left'>名称：{{ scope.row.card.cardName ? scope.row.card.cardName : '--' }}</div>
            <div style='text-align: left'>总次数：{{ scope.row.card.cardTimes ? scope.row.card.cardTimes : '--' }}</div>
            <!-- <div style='text-align: left'>可使用次数：{{ scope.row.card.limitTimes ? scope.row.card.limitTimes : '--' }}</div> -->
            <!-- <div style='text-align: left'>姓名：{{ scope.row.user.userRealname ? scope.row.user.userRealname : '--' }}</div> -->
          </div>
          <div v-else>--</div>
          <!-- <div v-if="scope.row.card" style='text-align: left'>名称：{{scope.row.card.cardName}}</div>
          <div v-else>--</div> -->
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="buyId"
        label="购买"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        min-width="180"
      >
        <template slot-scope='scope'>
          <div v-if="scope.row.user">
            <div style='text-align: left'>账号：{{ scope.row.user.userName ? scope.row.user.userName : '--' }}</div>
            <div style='text-align: left'>手机：{{ scope.row.user.userMobile ? scope.row.user.userMobile : '--' }}</div>
            <div style='text-align: left'>昵称：{{ scope.row.user.userNickname ? scope.row.user.userNickname : '--' }}</div>
            <div style='text-align: left'>姓名：{{ scope.row.user.userRealname ? scope.row.user.userRealname : '--' }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="useTimes"
        label="使用次数"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopTimescardUse(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopTimescardUse(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopTimescardUse(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopTimescardUseStates[shopTimescardUseState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="shopTimescardUse"
          ref="shopTimescardUseForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="次卡种类"
            prop="cardId"
          >
            <el-input
              size="small"
              style='width: 186px'
              v-model="shopTimescardUse.cardId"
              :disabled="shopTimescardUseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="购买"
            prop="buyId"
          >
            <el-input
              size="small"
              style='width: 186px'
              v-model="shopTimescardUse.buyId"
              :disabled="shopTimescardUseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="shopTimescardUse.userId"
              :disabled="shopTimescardUseState == 'check'"
            ></el-input> -->
            <GridSelect
                title='选择用户'
                labelName='userName'
                labelValue='id'
                :value='shopTimescardUse.userId'
                :disabled="shopTimescardUseState == 'check'"
                :limit='1'
                style='width: 186px'
                size='small'
                placeholder='请选择用户'
                @getValue='getValue'
                :columns="USER_code"
                :searchs="USER_search"
                dataListUrl='/mpp/user/findList'
                entityBeanName='mppUser'
                queryEntityUrl='/mpp/user/get'
            >
            </GridSelect>
          </el-form-item>
          <el-form-item
            label="使用次数"
            prop="useTimes"
          >
            <el-input
              size="small"
              style='width: 186px'
              v-model="shopTimescardUse.useTimes"
              :disabled="shopTimescardUseState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopTimescardUseState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    props: {
        id:{
          type: String,
          default:''
        }
    },
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect,
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopTimescardUseList();
                    this.getShopTimescardUseList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopTimescardUseList();
                    this.getShopTimescardUseList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     cardId: '', //次卡种类
                     buyId: '', //购买
                     userId: '', //用户
                     useTimes: '', //使用次数
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopTimescardUseState: 'add',
                shopTimescardUseStates: {
                    add: '新建用卡记录',
                    check: '查看用卡记录',
                    edit: '修改用卡记录'
                },

                multipleSelection: [],
                shopTimescardUseList: [],
                shopTimescardUse: {
                    id: '', //ID
                    cardId: '', //次卡种类
                    buyId: '', //购买
                    userId: '', //用户
                    useTimes: '', //使用次数
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    cardId: [{ required: true, message: '次卡种类不能为空', trigger: 'blur' }],
                    buyId: [{ required: true, message: '购买不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    useTimes: [{ required: true, message: '使用次数不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            // this.getShopTimescardUseList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValue(val){
              this.shopTimescardUse.userId = val;
            },
            getValue1(val){
              this.queryForm.userId = val;
            },
            resetShopTimescardUseList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopTimescardUseList = [];
            },
            resetDialog() {
                this.shopTimescardUseState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      cardId: '', //次卡种类
                      buyId: '', //购买
                      userId: '', //用户
                      useTimes: '', //使用次数
                };
                this.getShopTimescardUseList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopTimescardUse = {
                      id: '', //ID
                      cardId: '', //次卡种类
                      buyId: '', //购买
                      userId: '', //用户
                      useTimes: '', //使用次数
                };
            },
            submitForm() {
                if (this.shopTimescardUseState == 'add') {
                    this.$refs.shopTimescardUseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/timescarduse/add`,{ ...this.shopTimescardUse }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopTimescardUseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopTimescardUseState == 'edit') {
                    this.$refs.shopTimescardUseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopTimescardUse.card
                            delete this.shopTimescardUse.buy
                            delete this.shopTimescardUse.user
                            post(`/shop/timescarduse/edit`,{ ...this.shopTimescardUse }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopTimescardUseList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopTimescardUse() {
                this.showDialog = true;
                this.shopTimescardUseState = 'add';
            },
            checkShopTimescardUse(shopTimescardUseId) {
                console.log(shopTimescardUseId);
                this.currentShopTimescardUseId = shopTimescardUseId;

                this.getShopTimescardUseById();
                this.showDialog = true;
                this.shopTimescardUseState = 'check';
            },
            editShopTimescardUse(shopTimescardUseId) {
                console.log('shopTimescardUse', shopTimescardUseId);
                if (shopTimescardUseId) {
                    this.currentShopTimescardUseId = shopTimescardUseId;
                    this.getShopTimescardUseById();
                } else {
                    this.shopTimescardUse = { ...this.shopTimescardUse, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopTimescardUseState = 'edit';
            },
            deleteShopTimescardUse(shopTimescardUseId) {
                let ids = '';
                if (shopTimescardUseId) {
                    ids = shopTimescardUseId;
                } else {
                    ids = this.multipleSelection.map((shopTimescardUse) => shopTimescardUse.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/timescarduse/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopTimescardUseList();
                                this.getShopTimescardUseList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopTimescardUseList() {
                this.resetShopTimescardUseList();
                this.getShopTimescardUseList();
            },
            getShopTimescardUseList(query = {}) {
                this.loading = true;
                this.queryForm.cardId = this.id
                get(`/shop/timescarduse/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopTimescardUseList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopTimescardUseById() {
                get(`/shop/timescarduse/get`,{ id: this.currentShopTimescardUseId }).then((res) =>{
                    if(res.success){
                      this.shopTimescardUse = { ...this.shopTimescardUse, ...res.shopTimescardUse };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopTimescardUseList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/timescarduse/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/timescarduse/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/timescarduse/importData`,formData);
              this.refreshShopTimescardUseList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopTimescardUseList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopTimescardUseList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>